import { buttonClass } from "../../components/ui/Button";
import { BrandFrame } from "./BrandFrame";

export function SignInPage({ returnTo }: { returnTo?: string }) {
  const target = returnTo?.startsWith("/") && !returnTo.startsWith("//") ? returnTo : "/";
  return (
    <BrandFrame>
      <h1 className="text-3xl font-semibold text-ink">Sign in</h1>
      <a
        href={`/api/auth/login?returnTo=${encodeURIComponent(target)}`}
        className={buttonClass({ variant: "primary" }, "mt-6 h-11 w-full")}
      >
        Sign in with Microsoft
      </a>
    </BrandFrame>
  );
}
